import type { siteMigration } from "replo-publisher/src/trpc/routers/siteMigration";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: siteMigrationRouter,
  client: siteMigrationClient,
  utils: siteMigrationUtils,
  options: siteMigrationOptions,
} = createTrpcRouterConfig<typeof siteMigration>({
  path: "siteMigration",
  queryClient: getNamespacedQueryClient("siteMigration"),
});

export {
  siteMigrationClient,
  siteMigrationRouter,
  siteMigrationUtils,
  siteMigrationOptions,
};
